import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Field } from "./shared";

// Enregistrer le résultat d'une visite réalisée → met à jour la conformité du contrat et la prochaine échéance
export function DoneVisitDialog({ visit, results, onClose, onSaved }) {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (visit) { const sched = visit.scheduled_at?.slice(0, 10); const today = new Date().toISOString().slice(0, 10); setF({ done_at: sched && sched <= today ? sched : today, result: "apte", next_due: "", renforce: false, notes: "" }); } }, [visit]);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/chef/visites-medicales/${visit.id}/done`, { ...f, next_due: f.next_due || null }); toast.success(`Visite enregistrée : ${data.result_label} — prochaine échéance le ${new Date(data.next_due + "T12:00:00").toLocaleDateString("fr-FR")}`); onSaved?.(); onClose(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const set = (k) => (e) => setF({ ...f, [k]: e?.target ? e.target.value : e });
  return (
    <Dialog open={!!visit} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="vm-done-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl font-black">Visite réalisée</DialogTitle></DialogHeader>
        {f && (
          <div className="space-y-3">
            <div className="grid grid-cols-2 gap-3">
              <Field label="Date de la visite"><Input type="date" value={f.done_at} onChange={set("done_at")} data-testid="vm-done-date" className="h-10" /></Field>
              <Field label="Résultat / avis"><select value={f.result} onChange={set("result")} data-testid="vm-done-result" className="h-10 w-full border border-[#DEE2E6] bg-white px-2 text-sm">{Object.entries(results).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></Field>
            </div>
            <Field label="Prochaine échéance (laisser vide = calcul automatique selon la périodicité)"><Input type="date" value={f.next_due} onChange={set("next_due")} data-testid="vm-done-next" className="h-10" /></Field>
            <div className="flex items-center justify-between gap-3 border border-[#DEE2E6] p-3"><div><div className="text-sm font-semibold">Suivi individuel renforcé</div><div className="text-[11px] text-[#868E96]">Poste à risque : périodicité raccourcie</div></div><Switch checked={f.renforce} onCheckedChange={set("renforce")} data-testid="vm-done-renforce" /></div>
            <Field label="Observations (aménagements, restrictions…)"><Textarea value={f.notes} onChange={set("notes")} rows={2} data-testid="vm-done-notes" /></Field>
          </div>
        )}
        <DialogFooter><Button variant="outline" onClick={onClose} className="h-10">Annuler</Button><Button onClick={save} disabled={busy || !f} data-testid="vm-done-save" className="h-10 bg-[#059669] hover:bg-[#047857] text-white">Enregistrer</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
